import { ReviewCard } from "./ReviewCard/ReviewCard";
import "./Reviews.scss";
import { useGetReviews } from "hooks/reviews";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
interface IReviewPage {
  featured?: boolean;
  isPage? : boolean;
}
const Review: React.FC<IReviewPage> = ({isPage=false,  featured = true }) => {
  const navigate= useNavigate();
  const {
    data,
    isError,
    isLoading,
  } = useGetReviews({ isFeatures: 1 });
  if (isLoading) return <Loader />;
  if (isError || !data) return <div>Error fetching reviews</div>;
  const {reviews, metadata} = data;
  return (
    <div className="review-container" style={isPage ? { marginTop: '150px' } : {}}>
      <div className="header" onClick={()=>{!isPage && navigate('/reviews')}} style={isPage ? {}: {cursor: 'pointer'}}>
        <h2 className="section-title text-4xl font-semibold">20,000+ Sellers Trust Sellerdash.</h2>
        <p>Following are some of the Reviews from Our Satiffied customers.</p>
      </div>
      <div className="review-grid">
        <div className="review-column">
          {reviews
            ?.slice(0, Math.ceil((reviews.length * 1) / 3))
            .map((review, index) => (
              <ReviewCard key={index} {...review} />
            ))}
        </div>
        <div className="review-column">
          {reviews
            ?.slice(
              Math.ceil((reviews.length * 1) / 3),
              Math.ceil((reviews.length * 2) / 3)
            )
            .map((review) => (
              <ReviewCard key={review.name} {...review} />
            ))}
        </div>
        <div className="review-column">
          {reviews
            ?.slice(Math.ceil((reviews.length * 2) / 3), reviews.length)
            .map((review) => (
              <ReviewCard key={review.id} {...review} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Review;
